/* eslint-disable jsx-a11y/alt-text */
import { makeStyles } from '@material-ui/core';
import Image from 'next/image';
import React, { useCallback, useEffect, useState } from 'react';
import { delayTimer } from '../../../utility/cr-common';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '884px',
    minHeight: 'calc(100vh - 64px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 20px',
  },
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '60px',
    maxWidth: '1200px',
    width: '100%',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    color: '#062b68',
    fontFamily: 'IBM Plex Sans',
    flex: 1,
    maxWidth: '500px',
  },
  heading: {
    fontSize: '49px',
    lineHeight: '1.2',
    fontWeight: 'bold',
    margin: '0 0 0px 0',
  },
  subHeading: {
    fontSize: '26px',
    fontWeight: '600',
    margin: '0 0 10px 0',
  },
  paragraph: {
    fontSize: '16px',
    lineHeight: '1.6',
    margin: '0',
    textAlign: 'left',
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
  },
  image: {
    borderRadius: '8px',
  },
}));

const UnderMaintenance = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  const loadPage = useCallback(async () => {
    await delayTimer(3000);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadPage();
  }, [loadPage]);

  return (
    <div className={classes.root}>
      <div className={classes.mainContainer}>
        <div className={classes.textContainer}>
          {/* <h1 className={classes.heading}>Quattr Maintenance</h1>
          <h1 className={classes.subHeading}>Work In Progress</h1> */}
          <h1 className={classes.heading}>Sorry!</h1>
          <h1 className={classes.subHeading}>We are undergoing scheduled maintenance.</h1>
          <p className={classes.paragraph}>
            We are working to ensure optimal service quality and system performance. We apologize for the inconvenience.
            Hang tight—we'll notify you via email as soon as we're back up. Thank you for your patience and
            understanding.
          </p>
        </div>
        <div className={classes.imageContainer}>
          <Image
            className={classes.image}
            src={'/Maintenance.png'}
            height="432"
            width="432"
            layout="fixed"
            alt="Maintenance illustration"
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(UnderMaintenance);
